import { render } from "./Temperature.vue?vue&type=template&id=1b9386b4&scoped=true&ts=true"
import script from "./Temperature.vue?vue&type=script&lang=ts"
export * from "./Temperature.vue?vue&type=script&lang=ts"

import "./Temperature.vue?vue&type=style&index=0&id=1b9386b4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9386b4"]])

export default __exports__